<template>
  <learning-item-view
    :item="item"
    :responses-complete="true"
    :show-complete="true"
  />
</template>
<script>
import LearningItemView from "@/containers/learnings/LearningItemView"
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  components: {
    LearningItemView
  },
  data() {
    return {
      learningItemId: this.$route.params.id
    }
  },

  computed: {
    item() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item ? item : {}
    }
  },

  created() {
    this.addListener("learningResponse:save", model => {
      this.$store.dispatch("learningItems/updateLearningItemResponse", {
        id: model.id,
        learningItemId: model.learning_item_id,
        value: model.value
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.learningItemId = to.params.id
    }
    next()
  }
}
</script>
